import { FLEXI_REQUESTS_URL } from '../../endpoints';
import makeAuthenticatedRequest from '../base-api';
import type { GetFlexiRequestsParams, GetFlexiRequestsResponse, IFlexiRequest } from '../../types/flexi';

const getFlexiRequestsQueryKey = (
  status?: string,
  brandId?: string,
  kimId?: string
) => ['flexi-requests', status, brandId, kimId].filter(Boolean);

const getFlexiRequests = async (params?: GetFlexiRequestsParams): Promise<GetFlexiRequestsResponse> => {
  try {
    const queryParams = new URLSearchParams();
    if (params?.status) queryParams.append('status', params.status);
    if (params?.brandId) queryParams.append('brandId', params.brandId);
    if (params?.kimId) queryParams.append('kimId', params.kimId);

    const url = `${FLEXI_REQUESTS_URL}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;

    const response = await makeAuthenticatedRequest(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch flexi requests: ${response.statusText}`);
    }

    const result: GetFlexiRequestsResponse = await response.json();

    if (!result.success) {
      throw new Error(result.message);
    }

    return result;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export { getFlexiRequests, getFlexiRequestsQueryKey };
